export const formatString = (string: string) => {
  return string.toLowerCase().trim().replace(/\s+/g, "-");
};
